<script>
import ScaledBar from '@/V2/components/charts/ScaledBar';
import TrustScoreDisplay, {
  TrustScoreDisplaySizes,
} from '@/V2/documents/TrustScoreDisplay';
import { mapActions, mapGetters } from 'vuex';
import ItemButton from '@/V2/components/ItemButton';
import { TrustScoreDistributionDataSets } from '@/V2/stores/SimilarDocumentsStore';

export default {
  components: {
    ItemButton,
    ScaledBar,
    TrustScoreDisplay,
  },
  props: {
    document: {
      type: Object,
      default: undefined,
    },
    customerId: {
      type: String,
      default: undefined,
    },
  },
  data: () => ({
    TrustScoreDisplaySizes,
    TrustScoreDistributionDataSets,
  }),
  computed: {
    ...mapGetters({
      hasWorskpaceData: 'hasWorskpaceData',
      hasInscribeData: 'hasInscribeData',
      getSimilarDocumentsCount: 'getSimilarDocumentsCount',
      getLoading: 'getLoading',
    }),
    shouldDisplayChart() {
      return this.hasWorskpaceData || this.hasInscribeData;
    },
  },
  mounted() {
    if (
      typeof this.document.trust_score === 'number' &&
      typeof this.$refs.trustScoreDisplay?.$el !== 'undefined'
    ) {
      let leftPos = this.document.trust_score;
      if (this.document.trust_score > 97) {
        leftPos = 97;
      } else if (this.document.trust_score <= 3) {
        leftPos = 3;
      }
      this.$refs.trustScoreDisplay.$el.style.left = `${leftPos}%`;
    }

    setTimeout(() => {
      this.loadData();
    });
  },
  methods: {
    ...mapActions({
      loadScoreDistribution: 'loadScoreDistribution',
    }),
    onShowDetails() {
      this.$emit('show-trustscore-details');
    },
    loadData() {
      this.$store.dispatch('loadSimilarDocuments', {
        customerId: this.customerId,
        documentId: this.document.id,
      });

      // load Data
      const calls = [
        TrustScoreDistributionDataSets.WORKSPACE,
        TrustScoreDistributionDataSets.INSCRIBE,
      ].map(
        (type) =>
          new Promise((resolve, reject) => {
            this.loadScoreDistribution({
              documentId: this.document.id,
              customerId: this.customerId,
              type: type,
            }).then(resolve);
          }),
      );

      Promise.all(calls).then(() => {});
    },
    viewDetails() {
      this.$emit('show-similar-documents');
    },
  },
};
</script>

<template>
  <div
    v-if="document.trust_score || document.trust_score === 0"
    class="document-trust-score d-flex flex-column align-items-start justify-content-between i-pb-10"
  >
    <!-- trust container -->
    <div
      class="trust-container d-flex flex-column i-pt-8"
      data-testid="trust-score"
    >
      <scaled-bar :with-lines="true"></scaled-bar>
      <trust-score-display
        ref="trustScoreDisplay"
        :score="document.trust_score"
        :dark-mode="true"
        :size="TrustScoreDisplaySizes.MEDIUM"
      />
    </div>

    <!-- similar documents button -->
    <item-button
      v-if="!getLoading && (shouldDisplayChart || getSimilarDocumentsCount > 0)"
      icon="medium-graph-2"
      data-testid="similar-documents-button"
      primary-text="Similar Documents"
      secondary-text="How does this document compare?"
      class="i-mt-11"
      :on-btn-click="viewDetails"
    ></item-button>
  </div>
</template>

<style lang="scss" scoped>
.document-trust-score {
  .trust-container {
    position: relative;
    width: 100%;
    height: 60px;

    .trust-score {
      position: absolute;
      top: 18px;
      transform-origin: center;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
